$(function () {
	var index = {
		init: function init() {
			this.yuyue()
			this.navTwo()
			this.navThree()
			this.goTop()
			this.toast()
			this.video()
			this.teacher()
		},
		navThree: function () {
			var swiperTwo = function () {
				new Swiper('.book_box', {
					autoplay: {
						delay: 2000,
						disableOnInteraction: true,
					},
					loop: true,
					effect: 'coverflow',
					slidesPerView: 3,
					centeredSlides: true,
					coverflowEffect: {
						rotate: 0,
						stretch: 40,
						depth: 300,
					},
				})
			}
			$('.book_item').click(function () {
				$(this).addClass('active').siblings().removeClass('active')
				$('.book_list').eq($(this).index()).show().siblings().hide()
				swiperTwo()
			})
			swiperTwo()
		},
		teacher: function () {
			var oTabB = document.getElementsByClassName('reason_tab')
			var oContentB = document.getElementsByClassName('reason_content')
			function addClass(elem, value) {
				if (!elem.className) {
					elem.className = value
				} else {
					var newClassName = elem.className
					newClassName += ' '
					newClassName += value
					elem.className = newClassName
				}
			}

			function deleteClass(elem, value) {
				var newClassName = elem.className

				if (newClassName.indexOf(value)) {
					elem.className = newClassName.replace(value, ' ')
				}
			}
			for (var i = 0, len = oTabB.length; i < len; i++) {
				oTabB[i].index = i

				oTabB[i].onmouseover = function () {
					var This = this

					for (var j = 0; j < len; j++) {
						deleteClass(oTabB[j], 'activeTabNew')
						deleteClass(oContentB[j], 'activeNew')
					}

					addClass(This, 'activeTabNew')
					addClass(oContentB[This.index], 'activeNew')
				}
			}
		},
		video: function () {
			TCPlayer('videoPlayerA', {
				fileID: '5285890805550656146',
				appID: '1259605108',
				autoplay: false,
			})
		},
		navTwo: function navTwo() {
			// console.log($('.znqd_gift').offset().top)
			var prizeSwiper = function () {
				new Swiper('#prizeSwiper', {
					autoplay: true,
					loop: true,
					slidesPerView: 4.2,
				})
			}
			$('.shili_item').click(function () {
				$(this).addClass('active').siblings().removeClass('active')
				$('.shili_list').eq($(this).index()).show().siblings().hide()
				prizeSwiper()
			})
			prizeSwiper()
		},

		goTop: function () {
			$('.piaofu_guanbi').click(function () {
				$('.piaofu').hide()
			})
			$('.piaofu_btn').click(function () {
				$('html,body').animate(
					{
						scrollTop: 0,
					},
					500
				)
			})
		},
		yuyue: function () {
			$('.yuyue_form_txt ').click(function () {
				$('.yuyue_form_selectBox').show()
			})
			$('.yuyue_form_selectItem').click(function () {
				var _this = $(this)
				$('.yuyue_form_txt ').text(_this.text())
				$('.info_city').val(_this.text())
				$('.yuyue_form_selectBox').hide()
			})
			$('.yuyue_form').listenForm({
				contentName: [
					{
						search: '?jtppzq',
						name: 'PC寒假班预约（百品）',
					},
					{
						search: '?360jtppzq',
						name: 'PC寒假班预约（360）',
					},
					{
						search: '',
						name: 'PC寒假班预约',
					},
				],
				submitTarget: '.yuyue_form_btn',
				cityRequired: true,
			})

			$('.kuang_city .option').click(function () {
				var _this = $(this)
				$('.kuang_city .current').text(_this.text())
				$('.hidden_city').val(_this.text())
			})

			$('.youhui_form').listenForm({
				contentName: [
					{
						search: '?jtppzq',
						name: 'PC寒假班优惠（百品）',
					},
					{
						search: '?360jtppzq',
						name: 'PC寒假班优惠（360）',
					},
					{
						search: '',
						name: 'PC寒假班优惠',
					},
				],
				submitTarget: '.kuang_btn',
				cityRequired: true,
			})

			$('.form').listenForm({
				contentName: [
					{
						search: '?jtppzq',
						name: ' PC寒假班底部（百品）',
					},
					{
						search: '?360jtppzq',
						name: 'PC寒假班底部（360）',
					},
					{
						search: '',
						name: 'PC寒假班底部',
					},
				],
				submitTarget: '#submitBtn2',
				courseRequired: true,
				cityRequired: true,
			})
			$('.select-one .option').click(function () {
				var _this = $(this)

				$('.select-one .current').text(_this.text())
				$('.couse01').val(_this.text())
			})
			$('.select-city .option').click(function () {
				var _this = $(this)

				$('.select-city .current').text(_this.text())
				$('.city03').val(_this.text())
			})
			$('.guanbi ').click(function () {
				$('.form').hide()
			})
		},
		toast: function () {
			$('.zixun').click(function () {
				$('.toumingbi_yspd').show()
				$('.leyu_yspd').show()
			})
			$('.close_ly').click(function () {
				$('.toumingbi_yspd').hide()
				$('.leyu_yspd').hide()
			})
		},
	}
	index.init()
})
